import { useEffect, useState, useContext, useRef } from "react";
import $ from "jquery";
import {Accordion,Card,ListGroup,Button,Modal,Form, Alert, Row, Col, Dropdown} from 'react-bootstrap';
import {BsFillPencilFill,BsFillHouseDoorFill,BsPeople,BsFileEarmarkRuledFill,BsEye, BsSearch, BsInfoCircle} from 'react-icons/bs';
import {
  useNavigate
  } from "react-router-dom";
  import Spinner from 'react-bootstrap/Spinner';
  import UserContext from "../../contexts/UserContext";
import { set } from "mongoose";
import { FaPhoneAlt } from "react-icons/fa";

const Profile = () => {
  const navigate = useNavigate();

const [show, setShow] = useState(false);
const [dateShow, setDateShow] = useState(false);
const [addShow, setAddShow] = useState(false);
const[currentProfile,setCurrentProfile] = useState({});
const[sabeel, setSabeel] = useState(""); 
const[hof, setHof] = useState(""); 
const[name, setName] = useState(""); 
const [suggestions, setSuggestions] = useState([]); 
const inputRef = useRef(null);
const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);
const [clicked, setClicked] = useState(false); 

const [mohallas,setMohallas] = useState([]);
const [subMohallas,setSubMohallas] = useState([]);
const [subMohallasInNewProfile,setSubMohallasInNewProfile] = useState([]);
const [userMohallas,setUserMohallas] = useState([]);
const [userSubMohallas,setUserSubMohallas] = useState([]);
const [selectedMohalla,setSelectedMohalla] = useState(null);
const [userSelectedMohalla,setUserSelectedMohalla] = useState(null);
const [userSelectedSubMohalla,setUserSelectedSubMohalla] = useState(null);
const [currentSelectedMohalla,setCurrentSelectedMohalla] = useState(null);
const [flat,setFlat] = useState(null);
const[totalTakhmeen, setTotalTakhmeen] = useState(null); 

const handleClose = () => setShow(false);
const handleDateClose = () => setDateShow(false);
const handleAddClose = () => setAddShow(false);
const {user,setUser} = useContext(UserContext);
const [isLoading, setLoading] = useState(true);
const [message,setMessage] = useState(null);
const [takingTiffin, setTakingTiffin] = useState(null);

  async function getDataForUser(){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsersSession",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response && response.user){
           setUser(response.user);
           setLoading(false)
        }else{
          setUser(null)
          navigate("/login");
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
  }

async function getUser(userId){
  await $.ajax({
    type:"GET",
    url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
    xhrFields: {
        withCredentials: true  // Include cookies
      },
      crossDomain: true, 
     success :async function(response){
      if(response && response.user){
        setUser(response.user);
        if(!(response.user.role==='admin')){
          setLoading(false);
        }
      }else{
        setUser(null);
        navigate("/login",{state: { message: response.message }})
      }

    },
    error: function(err){
        console.log("error")
        console.log(err)
        setLoading(false);
    }
})
}


function getMohallas(){
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getMohallas",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response);
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          setMohallas(response.data)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
}

function getSubMohallas(e){
  console.log(e.target.value)
  var mohallaSelected=null;
  if(!e.target.value.includes('Select')){
      mohallaSelected = e.target.value
  if(!e.target.value){
      setMessage("Please Select Mohalla !")
  }
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+`/getSubMohallas?mohalla=${mohallaSelected}`,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response)
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          const foundMohalla = mohallas.find(mohalla => mohalla._id === e.target.value);
          // setUserSelectedMohalla(foundMohalla)
          setSubMohallas(response.data)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
  }
}

function getSubMohallasInNewProfile(e){
  console.log(e.target.value)
  var mohallaSelected=null;
  if(!e.target.value.includes('Select')){
      mohallaSelected = e.target.value
  if(!e.target.value){
      setMessage("Please Select Mohalla !")
  }
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+`/getSubMohallas?mohalla=${mohallaSelected}`,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response)
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          const foundMohalla = mohallas.find(mohalla => mohalla._id === e.target.value);
          // setUserSelectedMohalla(foundMohalla)
          setSubMohallasInNewProfile(response.data)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
  }
}

function getMohallasForUser(profile){
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getMohallas",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response);
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          setUserMohallas(response.data)
          console.log(profile.sector.name,profile.sector._id)
          setUserSelectedMohalla(profile.sector._id)
          getSubMohallasForUser(profile)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
}

function getSubMohallasForUser(profile){
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+`/getSubMohallas?mohalla=${profile.sector._id}`,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response)
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          setUserSubMohallas(response.data)
          console.log("in setting sub mohallas",profile.subSector.name,profile.subSector._id)
          setUserSelectedSubMohalla(profile.subSector._id)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
}

function handleMohallaChange(e){
  console.log("e value")
  console.log(e.target.value)
  var mohallaSelected=null;
  if(!e.target.value.includes('Select')){
      mohallaSelected = e.target.value
  if(!e.target.value){
      setMessage("Please Select Mohalla !")
  }
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+`/getSubMohallas?mohalla=${mohallaSelected}`,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response)
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          console.log(mohallas)
          console.log(e.target.value)
          const foundMohalla = mohallas.find(mohalla => String(mohalla._id) === String(mohallaSelected));
          console.log("foundMohalla")
          console.log(foundMohalla)
          setUserSelectedMohalla(foundMohalla._id)
          setUserSubMohallas(response.data)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
  }
}

function getDataForSubMohalla(e){
  setFlat(null);
  console.log(e.target.value)
  var submohallaSelected=null;
  if(!e.target.value.includes('Select')){
      submohallaSelected = e.target.value
      setCurrentSelectedMohalla(e)
  
  if(!e.target.value){
      setMessage("Please Select Sub Mohalla !")
  }
  $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+`/getDataForSubMohalla?submohalla=${submohallaSelected}`,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          console.log(response)
          if(response.message  && response.message.includes("Error in auth")){
              navigate("/login",{state: { message: response.message }})
          }
          setSelectedMohalla((mohalla) =>({
              ...mohalla,
              subSector:[response.data]
          }))
          // setSubMohallaData(response.data)
          setLoading(false);
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setLoading(false);
          navigate("/login")
      }
  })
  }
}

function editProfile(profile){
  setShow(true);
  setCurrentProfile(profile);
  console.log(profile)
  getMohallasForUser(profile);
}

function updateProfile(e){
    e.preventDefault();
  const profile={};
  profile.sabeel=e.target.sabeel.value;
  profile.name=e.target.name.value;
  profile.hof=e.target.its.value;
  profile.address=e.target.address.value;
  profile.members=e.target.count.value;
  profile._id=currentProfile._id;
  profile.takingTiffin=takingTiffin === "true" ? true : (takingTiffin === "false" ? false : null);
  profile.tiffinSize=e.target.tiffinSize.value;
  profile.mohalla=userSelectedMohalla;
  profile.subMohalla=userSelectedSubMohalla;
  console.log(profile)
  $.ajax({
    type:"PUT",
    url:process.env.REACT_APP_API_URL+"/updateProfile",
    xhrFields: {
        withCredentials: true  // Include cookies
      },
      crossDomain: true, 
    data:{profile},
    dataType: 'json',
     success : function(response){
      console.log(response)
      if(response.message  && response.message.includes("Error in auth")){
        navigate("/login",{message:response.message});
      }
      setMessage(response?.message)
      if(flat){
        setFlat(response?.profile);
      }else{
        getDataForSubMohalla(currentSelectedMohalla);
      }
    },
    error: function(err){
        console.log("error")
        console.log(err)
    }
})

handleClose();
}

const showDates = (profile)=>{
  setDateShow(true)
  setCurrentProfile(profile)
}

const addNewUser = (e) => {
  e.preventDefault();
  const profile={};
  profile.sabeel=e.target.sabeel.value;
  profile.name=e.target.name.value;
  profile.hof=e.target.its.value;
  profile.address=e.target.address.value;
  profile.members=e.target.count.value;
  profile._id=currentProfile._id;
  profile.takingTiffin=takingTiffin === "true" ? true : (takingTiffin === "false" ? false : null);
  profile.tiffinSize=e.target.tiffinSize.value;
  profile.mohalla=e.target.newMohalla.value.includes("Select") ? null : e.target.newMohalla.value;
  profile.subMohalla=e.target.newSubMohalla.value.includes("Select") ? null : e.target.newSubMohalla.value;
  console.log(profile)
  $.ajax({
    type:"POST",
    url:process.env.REACT_APP_API_URL+"/newProfile",
    xhrFields: {
        withCredentials: true  // Include cookies
      },
      crossDomain: true, 
    data:{profile},
    dataType: 'json',
     success : function(response){
      if(response.message  && response.message.includes("Error in auth")){
        navigate("/login",{message:response.message});
      }
      if(response?.message && response?.message.includes("success")){
        setMessage(response?.message) 
      }else{
        if(response?.message){
          setMessage(response?.message)
        }else{
          setMessage("Error ! Something went wrong !")
        }
      }
    },
    error: function(err){
        console.log("error")
        console.log(err)
    }
  })
  handleAddClose();
}

useEffect(() => {
  if (user && user.role === 'admin') {
    getMohallas();
  }else{
    try{
    if(!user && localStorage.getItem('userSession')){
      getUser(JSON.parse(localStorage.getItem('userSession')))
    }else{
      if(!user){
        getDataForUser();
      }else{
        setLoading(false)
      }
    }
  }catch(e){
    if(!user){
      getDataForUser();
    }else{
      setLoading(false)
    }
  }
  }
}, [user]);

const InfoCard = () => {
  return (
    <Card
      style={{
        background: "linear-gradient(135deg, #FCE3C8, #F9E0BB)",
        border: "1px solid #D4A373",
        borderRadius: "12px",
        width: "90%",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        margin: "20px auto",
        padding: "16px",
        textAlign: "center",
      }}
    >
      <Card.Body>
        <BsInfoCircle size={24} style={{ color: "#6F4E37", marginBottom: "10px" }} />
        <Card.Text
          style={{
            fontSize: "16px",
            color: "#6F4E37",
            fontWeight: "500",
            lineHeight: "1.5",
          }}
        >
          Total hub due may include the previous dues carried forward to the current takhmeen.
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

const AccordionBlock = (block) => {
  const AccordionBlockDesign = (
  <>
      <Accordion.Item eventKey={block.data}>
                <Accordion.Header>{block?.data.name}</Accordion.Header>
                
                <Accordion.Body>
                    <ListGroup>
                        
       {console.log(block)}
                        
    {
    block?.data?.mumineen?.map((flat,i)=>{
                              return <Card key={i} className="mt-3 mx-3">
                              <Card.Header className='d-flex justify-content-between'>
                                <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
                                <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
                                </Card.Header>
                              <ListGroup>
                                  <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
                                  <ListGroup.Item  className='d-flex justify-content-between'>
                                    <div>{flat.hof}</div>
                                    {flat.members && <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>}
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    <div><BsFillHouseDoorFill />  {flat.address} </div>
                                  </ListGroup.Item>
                                  {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                                    <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                                    <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                                    </ListGroup.Item>):null}
                              </ListGroup>
                              </Card>
                          })
                      }
                  </ListGroup>
              </Accordion.Body>
      </Accordion.Item>
  </>
  )
  return AccordionBlockDesign;
}

const searchBySabeel = async () => {
  setClicked(false);
  setMessage('');
  var sabeelObj = {type:"sabeel",value:sabeel}
  await $.ajax({
      type:"POST",
      url:process.env.REACT_APP_API_URL+"/getUserByInfo",
      data:{sabeelObj},
      dataType:'json',
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          if(response.message && response.message.includes("not found")){
              setMessage(response.message)
          }else{
            setSelectedMohalla(null)
              setFlat(response)
              setHof("")
              setSabeel('');
          }
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setSabeel("")
      }
  })
}

const searchByHOF = async () => {
  setMessage('');
  var sabeelObj = {type:"hof",value:hof}
  await $.ajax({
      type:"POST",
      url:process.env.REACT_APP_API_URL+"/getUserByInfo",
      data:{sabeelObj},
      dataType:'json',
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          if(response.message && response.message.includes("not found")){
              setMessage(response.message)
}else{
              
              setFlat(response)
              setHof("")
              setSabeel('');
          }

      },
      error: function(err){
          console.log("error")
          console.log(err)
          setHof("")
          setSabeel('');
      }
  })
}

const searchByName = async () => {
  setClicked(false)
  setMessage('');
  var sabeelObj = {type:"name",value:name}
  await $.ajax({
      type:"POST",
      url:process.env.REACT_APP_API_URL+"/getUserByInfo",
      data:{sabeelObj},
      dataType:'json',
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
          if(response.message && response.message.includes("not found")){
              setMessage(response.message)
          }else{
              setSelectedMohalla(null)
              setSubMohallas([])
              setFlat(response)
              setName('');
              setHof("")
              setSabeel('');
          }
      },
      error: function(err){
          console.log("error")
          console.log(err)
          setName('');
          setHof("")
          setSabeel('');
      }
  })
}

useEffect(() => {
  // Make an AJAX call to fetch suggestions from the backend based on the inputValue
  // Replace the URL with your backend API endpoint
      const fetchData = async () => {
       await $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/sabeelSuggestions?query="+name,
           success : function(response){
              setSuggestions(response);
    
          },
          error: function(err){
              console.error('Error fetching suggestions:', err);
              setSabeel("")
          }
       })
      }

      // Fetch data only if inputValue is not empty
      if (name && name.trim() !== '') {
          if(!clicked){
              fetchData();
          }
      } else {
      setSuggestions([]); // Clear suggestions if inputValue is empty
      }
  }, [name]);

const handleSuggestionClick = (suggestion) => {
  setName(suggestion);
  setClicked(true);
  setSuggestions([]); // Clear suggestions after selecting one
};

const handleKeyDown = (e) => {
  if (e.key === 'ArrowDown' && selectedSuggestionIndex < suggestions.length - 1) {
    setSelectedSuggestionIndex(selectedSuggestionIndex + 1);
  } else if (e.key === 'ArrowUp' && selectedSuggestionIndex > 0) {
    setSelectedSuggestionIndex(selectedSuggestionIndex - 1);
  } else if (e.key === 'Enter' && selectedSuggestionIndex !== -1) {
    handleSuggestionClick(suggestions[selectedSuggestionIndex]);
  }
};

const calculateTotalTakhmeen=(profile)=>{
  let totalAmount = 0;
  profile.takhmeen.map((takhmeen)=>{
      totalAmount = takhmeen.amount + totalAmount;
  })
  setTotalTakhmeen(totalAmount)

}

const TakhmeenCard = ({profile}) => {
  calculateTotalTakhmeen(profile);
  const design = (
    <>
      <Card className="mt-3 mx-3">
          <Card.Header className='d-flex justify-content-between'>
          <div><BsFileEarmarkRuledFill className="svg-color"/> Takhmeen Details</div>
          </Card.Header>
              {profile && profile.takhmeen && profile.takhmeen.length>0?
              (
                  profile.takhmeen.map((currTakhmeen) => {
                      return (
                              currTakhmeen.year==='till1445'?
                              <ListGroup>
                                  <ListGroup.Item>Year : Till 1445H </ListGroup.Item>
                                  <ListGroup.Item>Hub Due : {currTakhmeen.amount}</ListGroup.Item>
                              </ListGroup>:
                              <ListGroup>
                                  <ListGroup.Item>Year : {currTakhmeen.year}  </ListGroup.Item>
                                  <ListGroup.Item>Takhmeen Amount : {currTakhmeen.amount}</ListGroup.Item>
                              </ListGroup>
                          )
                  })
              ):null
              }
          <ListGroup>
              <ListGroup.Item className="totalHub" style={{backgroundColor: '#402E32',fontWeight:'bold',color: 'white!important' }}>
                  Total Hub Due : {totalTakhmeen - profile.hubPaid}
              </ListGroup.Item>
          </ListGroup>      
      </Card>
    </>
  )
  return design;
}

const profileDesign = (
    <>
    {message?<Alert key='success' variant='success' >{message} !</Alert>:null}
    {
      (user && (user.role==='admin'))?
      (
        <div className="mt-3">
          <div className='m-2'>
        <Row>
            <Col>
                <div style={{width:'87%',display:'inline-block'}}>
                    <Form.Control style={{borderTopRightRadius:'0',borderBottomRightRadius:'0',borderColor:'white' }} type="text" placeholder="Search By Sabeel" value={sabeel} onChange={(e) => {setSabeel(e.target.value)}}/>
                </div>
            <Button style={{width:'12%',borderColor:'#dee2e6',borderTopLeftRadius:'0',borderBottomLeftRadius:'0',display:'inline-block',boxShadow:'none',marginTop:'-3px' }} type="button" onClick={searchBySabeel} >
                <BsSearch size={15} style={{color:'white!important'}} />
            </Button>
            </Col>
        </Row>
        <br/>
        <Row>
            <Col >
            <div style={{width:'87%',display:'inline-block'}}>  
                <Form.Control  style={{borderTopRightRadius:'0',borderBottomRightRadius:'0',borderColor:'white' }} type="text" placeholder="Search By HOF ITS" value={hof} onChange={(e) => {setHof(e.target.value)}}/>
            </div>
            <Button style={{width:'12%',borderColor:'#dee2e6',borderTopLeftRadius:'0',borderBottomLeftRadius:'0',display:'inline-block',boxShadow:'none',marginTop:'-3px' }} type="button" onClick={searchByHOF} >
                <BsSearch size={15} style={{color:'white!important'}} />
            </Button>
            </Col>
        </Row>
        <br/>
        <Row>
            <Col >
            <div style={{width:'87%',display:'inline-block'}}>
                <Form.Control  style={{borderTopRightRadius:'0',borderBottomRightRadius:'0',borderColor:'white' }}  type="text" placeholder="Search By Name" ref={inputRef} value={name} onChange={(e) => {setName(e.target.value)}} onKeyDown={handleKeyDown}/>  
                <Dropdown style={{ width: '100%' }} show={suggestions.length > 0} >

                <Dropdown.Menu>
                    {suggestions.map((suggestion, index) => (
                    <Dropdown.Item
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                    className={index === selectedSuggestionIndex ? 'active' : ''}
                  >
                    {suggestion}
                  </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
                </Dropdown>
            </div>
            <Button style={{width:'12%',borderColor:'#dee2e6',borderTopLeftRadius:'0',borderBottomLeftRadius:'0',display:'inline-block',boxShadow:'none',marginTop:'-3px' }} type="button" onClick={searchByName} >
                <BsSearch size={15} style={{color:'white!important'}} />
            </Button>
            </Col>
        </Row>
        </div>
        <h6 className="text-center">(OR)</h6>
        <Form.Select style={{width:'95%'}} className="d-flex m-3 mt-3 mx-2" aria-label="Select Mohalla" onChange={getSubMohallas}>
            <option>Select Mohalla</option>
            {
                mohallas.length>0?
                mohallas.map((mohalla) => {
                    return <option value={mohalla._id}>{mohalla.name}</option>
                }):null
            }
          </Form.Select>

          {
              subMohallas?.length>0?
              <Form.Select style={{width:'90%'}} className="d-flex m-3 mt-4" aria-label="Select Date " onChange={getDataForSubMohalla}>
                      <option>Select Sub Mohalla</option>
                      {
                          subMohallas.length>0?
                          subMohallas.map((submohalla) => {
                              return <option value={submohalla._id}>{submohalla.name}</option>
                          }):null
                      }
              </Form.Select>
              :
              null 
          }
        <Accordion>
            {
                selectedMohalla?.subSector?.map((block,index)=>{
                    return <AccordionBlock data={block} key={index}/>
                })
            }
          </Accordion>

        {
          flat && <Card className="mt-3 mx-3">
          <Card.Header className='d-flex justify-content-between'>
            <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
            <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
            </Card.Header>
          <ListGroup>
              <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
              <ListGroup.Item  className='d-flex justify-content-between'>
                <div>{flat.hof}</div>
                {flat.members && <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>}
              </ListGroup.Item>
              <ListGroup.Item>
                <div><BsFillHouseDoorFill />  {flat.address} </div>
              </ListGroup.Item>
              {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                </ListGroup.Item>):null}
          </ListGroup>
          </Card>
        }  
      
      <div className='d-flex mx-1 mt-3 justify-content-end'>
            <Button className='w-100' style={{backgroundColor:'#884A39',borderColor:'#884A39'}} onClick={()=>{setAddShow(true)}}> Add New + </Button>
      </div>
      </div>
      ):
      user && (
      <div>
        <Card className="mt-3 mx-3">
        <Card.Header className='d-flex justify-content-between'>
          <div><BsFileEarmarkRuledFill className="svg-color"/> {user?user.sabeel:null}</div>
          </Card.Header>
        <ListGroup >
            <ListGroup.Item className="custom-card">{user.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
            <ListGroup.Item  className='d-flex justify-content-between custom-card'>
              <div>{user.hof}</div>
              {user.members && <div className='d-inline'><BsPeople className='mx-1' />{user.members}</div>}
            </ListGroup.Item>
            {user?.address && <ListGroup.Item className="custom-card">
              <div><BsFillHouseDoorFill />  {user.address} </div>
            </ListGroup.Item>}
            {(user && user.tiffin&&user.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
              <div>Tiffin Taken : {user.tiffin.length === 1 &&  typeof user.tiffin[0] === 'object' ? user.tiffin[0][new Date().getFullYear()]['total'] : user.tiffin.length} days ( {new Date().getFullYear()} )</div>
              <div onClick={()=>{showDates(user)}}><BsEye /></div>
              </ListGroup.Item>):null}
        </ListGroup>
        </Card>

        {user && user.takhmeen?
        <>
          <TakhmeenCard profile = {user}/>
          <InfoCard/>
          </>  
          :null} 

        <div>
    {
      user.sector && user.sector?.masool ?
<Card className="mb-4 mt-4 mx-3 shadow-lg">
  <Card.Header
    className="text-center"
    style={{
      backgroundColor: '#884A39',
      color: 'white',
      borderRadius: '10px 10px 0 0',
    }}
  >
    Mohalla - {user.sector.name}
  </Card.Header>
  <Card.Body
    className="d-flex justify-content-between"
    style={{
      background: 'linear-gradient(to bottom right, #ffffff, #f8d8b1)',
      borderRadius: '0 0 10px 10px',
      fontSize:'0.8rem'
    }}
  >
    {user.sector.masool && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
            fontSize:'0.8rem'
          }}
        >
          Masool
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.sector?.masool?.name}
        </ListGroup.Item>
        {user?.sector?.masool?.phone &&<ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" /> Contact : {user?.sector?.masool?.phone}
          </div>
        </ListGroup.Item>}
      </ListGroup>
    )}

    {user.sector.masoola && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
          }}
        >
          Masoola
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.sector?.masoola?.name}
        </ListGroup.Item>
        <ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" />Contact : {user?.sector?.masoola?.phone}
          </div>
        </ListGroup.Item>
      </ListGroup>
    )}
  </Card.Body>
</Card>
      :
      null
    }

{
      user.subSector?
      <Card className="mb-4 mt-4 mx-3 shadow-lg">
  <Card.Header
    className="text-center"
    style={{
      backgroundColor: '#884A39',
      color: 'white',
      borderRadius: '10px 10px 0 0',
      fontSize:'0.8rem!important'
    }}
  >
    Sub Mohalla - {user.subSector.name}
  </Card.Header>
  <Card.Body
    className="d-flex justify-content-between"
    style={{
      background: 'linear-gradient(to bottom right, #ffffff, #f8d8b1)',
      borderRadius: '0 0 10px 10px',
      fontSize:'0.8rem'
    }}
  >
    {user.subSector.masool && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
            fontSize:'0.8rem'
          }}
        >
          Male Incharge
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.subSector?.masool?.name}
        </ListGroup.Item>
        <ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" /> Contact : {user?.subSector?.masool?.phone}
          </div>
        </ListGroup.Item>
      </ListGroup>
    )}

    {user.subSector.masoola && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
            fontSize:'0.4rem'
          }}
        >
          Female Incharge
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.subSector?.masoola?.name}
        </ListGroup.Item>
        <ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" /> Contact : {user?.subSector?.masoola?.phone}
          </div>
        </ListGroup.Item>
      </ListGroup>
    )}
  </Card.Body>
</Card>
      :
      null
    }
    </div>
      </div>
      )
    }

    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="menuForm" onSubmit={updateProfile}>
                <Form.Group className="mb-3">
                  <Form.Label>Sabeel</Form.Label>
                  <Form.Control name="sabeel" type="text" defaultValue={currentProfile.sabeel?currentProfile.sabeel:null} placeholder="Sabeel" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control name="name" type="text" defaultValue={currentProfile.name?currentProfile.name:null} placeholder="Name" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>ITS</Form.Label>
                  <Form.Control name="its" type="text" defaultValue={currentProfile.hof?currentProfile.hof:null} placeholder="ITS" required/>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Mohalla</Form.Label>
                  {/* <Form.Control name="flat" type="text" defaultValue={currentProfile.sector?.name?currentProfile.sector?.name:null} placeholder="Select Mohalla" /> */}
                  <Form.Select style={{width:'100%'}} value={userSelectedMohalla} aria-label="Select Mohalla" onChange={handleMohallaChange}>
                    <option>Select Mohalla</option>
                    {
                        userMohallas.length>0?
                        userMohallas.map((mohalla) => {
                            return <option value={mohalla._id}>{mohalla.name}</option>
                        }):null
                    }
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Sub Mohalla</Form.Label>
                  {/* <Form.Control name="flat" type="text" defaultValue={currentProfile.subSector?.name?currentProfile.subSector?.name:null} placeholder="Select Sub Mohalla" /> */}
                  <Form.Select style={{width:'100%'}} value={userSelectedSubMohalla} onChange={(event)=>setUserSelectedSubMohalla(event.target.value)} aria-label="Select Date ">
                          <option>Select Sub Mohalla</option>
                          {
                              userSubMohallas.length>0?
                              userSubMohallas.map((submohalla) => {
                                  return <option value={submohalla._id}>{submohalla.name}</option>
                              }):null
                          }
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control name="address" type="text" defaultValue={currentProfile.address?currentProfile.address:null} placeholder="Address" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Members Count</Form.Label>
                  <Form.Control name="count" type="text" defaultValue={currentProfile.members?currentProfile.members:null} placeholder="Family Members Count" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label> Taking Tiffin :</Form.Label>
                  <div>
                  <Form.Check type="radio" name="takingTiffin" value="true" label="Yes" defaultChecked={currentProfile.takingTiffin?currentProfile.takingTiffin:null} onChange={(e)=>setTakingTiffin(e.target.value)} inline />
                  <Form.Check type="radio" name="takingTiffin" value="false" label="No" defaultChecked={currentProfile?.takingTiffin === false} onChange={(e)=>setTakingTiffin(e.target.value)} inline/>
                  </div>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tiffin Size</Form.Label>
                  <Form.Control name="tiffinSize" type="text" defaultValue={currentProfile.tiffinSize?currentProfile.tiffinSize:null} placeholder="Tiffin Size taken by family" />
                </Form.Group>
                
            <Button variant="primary" type="submit">Submit</Button>
          </Form>
          </Modal.Body>
      </Modal>
        

      <Modal show={addShow} onHide={handleAddClose}>
        <Modal.Header closeButton>
          <Modal.Title>New Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="menuForm" onSubmit={addNewUser}>
                <Form.Group className="mb-3">
                  <Form.Label>Sabeel</Form.Label>
                  <Form.Control name="sabeel" type="number"  placeholder="Sabeel" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control name="name" type="text"  placeholder="Name" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>ITS</Form.Label>
                  <Form.Control name="its" type="number" placeholder="HOF ITS" required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Mohalla</Form.Label>
                  {/* <Form.Control name="flat" type="text" defaultValue={currentProfile.sector?.name?currentProfile.sector?.name:null} placeholder="Select Mohalla" /> */}
                  <Form.Select style={{width:'100%'}} aria-label="Select Mohalla" name="newMohalla" onChange={getSubMohallas}>
                    <option>Select Mohalla</option>
                    {
                        mohallas.length>0?
                        mohallas.map((mohalla) => {
                            return <option value={mohalla._id}>{mohalla.name}</option>
                        }):null
                    }
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Sub Mohalla</Form.Label>
                  {/* <Form.Control name="flat" type="text" defaultValue={currentProfile.subSector?.name?currentProfile.subSector?.name:null} placeholder="Select Sub Mohalla" /> */}
                  <Form.Select style={{width:'100%'}} aria-label="Select Date " name="newSubMohalla">
                          <option>Select Sub Mohalla</option>
                          {
                              subMohallas.length>0?
                              subMohallas.map((submohalla) => {
                                  return <option value={submohalla._id}>{submohalla.name}</option>
                              }):null
                          }
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control name="address" type="text" placeholder="Address" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Members Count</Form.Label>
                  <Form.Control name="count" type="text" placeholder="Family Members Count" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label> Taking Tiffin :</Form.Label>
                  <div>
                  <Form.Check type="radio" name="takingTiffin" value="true" label="Yes" onChange={(e)=>setTakingTiffin(e.target.value)} inline />
                  <Form.Check type="radio" name="takingTiffin" value="false" label="No" onChange={(e)=>setTakingTiffin(e.target.value)} inline/>
                  </div>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tiffin Size</Form.Label>
                  <Form.Control name="tiffinSize" type="text" placeholder="Tiffin Size taken by family" />
                </Form.Group>
                
            <Button variant="primary" type="submit">Submit</Button>
          </Form>
          </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleClose}> Save Changes</Button>
        </Modal.Footer> */}
      </Modal>
    </>
);
return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
</Spinner><br/>
<span style={{marginLeft:'-10px'}}>Loading...</span></div>: profileDesign;
}

export default Profile;